import script from "./PriceCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCategories.vue?vue&type=script&setup=true&lang=js"

import "./PriceCategories.vue?vue&type=style&index=0&id=1196e2fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1196e2fe"]])

export default __exports__